import React from 'react';

const CourseOverview = () => (
  <section className="course-overview">
    <h2>About the Course</h2>
    <p>This course is designed for IT professionals, developers, and AI enthusiasts who want to master Microsoft Azure AI solutions and earn the AI-102 certification.</p>
    <ul>
      <li>Gain in-demand skills for AI and cloud roles</li>
      <li>Prepare for the official Microsoft AI-102 certification exam</li>
      <li>Boost your career with industry-recognized credentials</li>
    </ul>
    <button className="secondary-cta">Download Syllabus</button>
  </section>
);

export default CourseOverview; 